class HeroBanner extends HTMLElement {
  constructor() {
    super();

    this.handleClick = this.handleClick.bind(this);
    this.tryInitPager = this.tryInitPager.bind(this);
    this.onSlideChange = this.onSlideChange.bind(this);

    this.pagerInitialized = false;
    this.initAttempts = 0;
    this.pagerInitTimeout = null;
    this.swiper = null;
    this.pagers = [];
  }

  connectedCallback() {
    this.addEventListener("click", this.handleClick);
    this.tryInitPager();
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.handleClick);

    if (this.pagerInitTimeout) {
      clearTimeout(this.pagerInitTimeout);
      this.pagerInitTimeout = null;
    }

    if (this.swiper && this.onSlideChange) {
      this.swiper.off("slideChange", this.onSlideChange);
    }
  }

  isMobile() {
    return window.innerWidth <= 1023;
  }

  handleClick(event) {
    const infoEl = event.target.closest("[data-banner-info]");
    if (!infoEl || !this.contains(infoEl)) return;
    if (!this.isMobile()) return;

    const href = infoEl.getAttribute("data-href");
    if (href) {
      window.location.href = href;
    }
  }

  tryInitPager() {
    if (this.pagerInitialized) return;

    const swiperEl = this.querySelector(".swiper");
    if (!swiperEl || !swiperEl.swiper) {
      if (this.initAttempts < 10) {
        this.initAttempts += 1;
        this.pagerInitTimeout = setTimeout(this.tryInitPager, 200);
      }
      return;
    }

    this.swiper = swiperEl.swiper;
    this.pagers = Array.from(this.querySelectorAll("[data-pager]"));

    if (!this.pagers.length) {
      return;
    }

    this.pagers.forEach((btn) => {
      btn.addEventListener("click", (event) => {
        event.preventDefault();

        const indexAttr = btn.getAttribute("data-index");
        const index = indexAttr ? Number(indexAttr) - 1 : 0;
        if (Number.isNaN(index)) return;

        if (this.swiper) {
          if (typeof this.swiper.slideToLoop === "function") {
            this.swiper.slideToLoop(index);
          } else {
            this.swiper.slideTo(index);
          }
        }
      });
    });

    this.swiper.on("slideChange", this.onSlideChange);

    this.pagerInitialized = true;
    this.updatePagerFromSwiper();
  }

  onSlideChange() {
    this.updatePagerFromSwiper();
  }

  updatePagerFromSwiper() {
    if (!this.swiper || !this.pagers.length) return;

    const realIndex =
      typeof this.swiper.realIndex === "number"
        ? this.swiper.realIndex
        : this.swiper.activeIndex || 0;

    const activeIndex = realIndex + 1; // data-index is 1-based

    this.pagers.forEach((btn) => {
      const btnIndex = Number(btn.getAttribute("data-index"));
      if (btnIndex === activeIndex) {
        btn.classList.add("active");
      } else {
        btn.classList.remove("active");
      }
    });
  }
}

customElements.define("hero-banner", HeroBanner);
